import React, { useEffect, useState } from 'react'
import { withTranslation  } from 'react-i18next'
import withRouter from '../../components/Common/withRouter'
import WebSocketService from '../../services/WebsocketService'
import { toast } from 'react-toastify'

const Dashboard = (props) => {
  document.title = props.t("app_title")

  // useEffect(() => {
  //   const webSocketService = new WebSocketService();
  //   webSocketService.connect((message => {
  //     toast.info(`${message}`);
  //   }));
  //   return () => webSocketService.disconnect();
  // }, []);


  return (
    <div className='container-fluide px-5'>
    </div>
  )
}

export default withRouter(withTranslation()(Dashboard));
